var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AIEvaluate from '../AIEvaluate';
import { CandidateReport, PodiumReport } from '../Candidate';
import { DinTypography, ReportBadge, ReportLabel } from '../styled';
import { INTERVIEW_STATUS } from "../../../../enum/ai-report";
import { PostAiInterviewRefresh } from "../../../../services/ai-report";
import { useAiReportStore } from "../../../../store/ai-report/global-store";
import { formatScore } from "../../../../utils/utils";
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { RefreshIcon, ShareIcon } from 'fbm-icons';
import { Box, Button, IconButton, Message, Popover, Typography } from 'fbm-ui';
import { Stack } from 'fbm-ui/lib/mui';
import { useEffect, useMemo, useState } from 'react';
var ReportHeader = function (_a) {
    var customScore = _a.customScore, onRefreshSuccess = _a.onRefreshSuccess, fetchCandidateInfo = _a.fetchCandidateInfo, status = _a.status, fetchReportUrl = _a.fetchReportUrl;
    var _b = __read(useState(false), 2), openRefresh = _b[0], setOpenRefresh = _b[1];
    var _c = __read(useState(null), 2), reportUrl = _c[0], setReportUrl = _c[1];
    var _d = useAiReportStore(function (store) { return [
        store.token,
        store.reportResult,
        store.operableButtons,
    ]; }), token = _d.token, reportResult = _d.reportResult, operableButtons = _d.operableButtons, onExportReportClick = _d.onExportReportClick;
    var _e = reportResult || {}, score = _e.score, createTime = _e.createTime, model = _e.model;
    var _f = __read(useState(score || 0), 2), feScore = _f[0], setScore = _f[1];
    var _g = useRequest(function () { return PostAiInterviewRefresh(token); }, {
        manual: true,
        onSuccess: function () {
            onRefreshSuccess();
            Message.success('刷新成功');
        },
    }), run = _g.run, loading = _g.loading;
    var level = useMemo(function () {
        if (feScore >= 80)
            return 'high';
        if (feScore >= 60)
            return 'middle';
        return 'low';
    }, [feScore]);
    useEffect(function () {
        if (!fetchReportUrl)
            return;
        fetchReportUrl()
            .then(function (_a) {
            var url = _a.url;
            setReportUrl(url);
        })
            .catch(function () { return Message.error('获取报告链接失败'); });
    }, [fetchReportUrl]);
    var content = (_jsxs(Box, __assign({ padding: 2 }, { children: [_jsx(Typography, __assign({ variant: "body1", color: "secondary" }, { children: "\u5237\u65B0\u540E\u5C06\u6309\u6700\u65B0\u7B97\u5206\u89C4\u5219\u8BA1\u7B97\uFF0C\u662F\u5426\u786E\u8BA4\u5237\u65B0" })), _jsx(Box, __assign({ paddingTop: 1, textAlign: "right" }, { children: _jsx(Button, __assign({ loading: loading, onClick: run }, { children: "\u5237\u65B0" })) }))] })));
    useEffect(function () {
        if (typeof customScore === 'number' && customScore > -1) {
            setScore(customScore);
        }
        else {
            setScore(score || 0);
        }
        if (!loading)
            setOpenRefresh(false);
    }, [loading, customScore, score]);
    return (_jsxs(Stack, __assign({ position: "relative" }, { children: [model === 'pro' && _jsx(ReportBadge, {}), _jsx(ReportLabel, { level: status === INTERVIEW_STATUS.COMPLETED ? level : 'calculation' }), _jsxs(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between", sx: {
                    width: 'calc(100% - 180px)',
                    position: 'absolute',
                    top: 0,
                    zIndex: 2,
                } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", pl: 3, py: 3 }, { children: [_jsxs(Typography, __assign({ variant: "caption", sx: {
                                    color: 'rgba(74, 74, 74, 0.86)',
                                } }, { children: ["\u62A5\u544A\u751F\u6210\u65F6\u95F4\uFF1A", dayjs(createTime && createTime * 1000).format('YYYY-MM-DD HH:mm')] })), (operableButtons === null || operableButtons === void 0 ? void 0 : operableButtons.includes('refresh')) && (_jsx(Popover, __assign({ open: openRefresh, content: content, onClickAway: function () { return setOpenRefresh(false); } }, { children: _jsx(IconButton, __assign({ onClick: function () { return setOpenRefresh(true); } }, { children: _jsx(RefreshIcon, { sx: {
                                            color: '#009908',
                                        } }) })) })))] })), _jsx(DinTypography, __assign({ variant: "h5", textAlign: "center", color: "#009D56", sx: { alignSelf: 'center' } }, { children: "AI \u9762\u8BD5\u62A5\u544A" })), (operableButtons === null || operableButtons === void 0 ? void 0 : operableButtons.includes('export')) ? (_jsx(Button, __assign({ endIcon: _jsx(ShareIcon, {}), variant: "text", onClick: onExportReportClick, sx: { borderRadius: 18, border: '1px solid #4caf50' } }, { children: "\u5BFC\u51FA\u62A5\u544A" }))) : reportUrl ? (_jsx("a", __assign({ href: reportUrl, title: "\u67E5\u770B\u5728\u7EBF\u62A5\u544A", style: {
                            textDecoration: 'none',
                        } }, { children: _jsx(Button, __assign({ endIcon: _jsx(ShareIcon, {}), variant: "text", sx: { borderRadius: 18, border: '1px solid #4caf50' } }, { children: "\u67E5\u770B\u5728\u7EBF\u62A5\u544A" })) }))) : (_jsx(Box, {}))] })), _jsxs(Stack, { children: [fetchCandidateInfo && status === INTERVIEW_STATUS.COMPLETED && _jsx(CandidateReport, { fetchCandidateInfo: fetchCandidateInfo }), !fetchCandidateInfo && status === INTERVIEW_STATUS.COMPLETED && _jsx(PodiumReport, { score: formatScore(feScore || 0) }), status !== INTERVIEW_STATUS.COMPLETED && (_jsx(Box, { sx: {
                            position: 'relative',
                            width: 541,
                            height: 342,
                        } }))] }), status === INTERVIEW_STATUS.COMPLETED && (_jsx(Stack, __assign({ width: 1, direction: "row" }, { children: _jsx(AIEvaluate, {}) })))] })));
};
export default ReportHeader;
